<template>
  <div class="block">
    <div class="block_">
      <el-carousel height="500px" :interval="5000">
        <el-carousel-item>
          <img class="swiper_img" src="@/assets/images/home.png" alt="Slide 1" />
        </el-carousel-item>
        <el-carousel-item>
          <img class="swiper_img" src="@/assets/images/home1.png" alt="Slide 2" />
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>




<script>
// import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import "swiper/js/swiper.min.js";
// import { getBannerList } from "@/apis/banner";

export default {
  data() {
    return {
      mySwiper: null,
      bannerList: []
    };
  },
  mounted() {},
  created() {
    // var me = this;
    // me.loadBannerList(
    //   {
    //     position: "首页",
    //     status: "0",
    //     pageSize: 10,
    //     pageNum: 20
    //   },
    //   function() {
    //     me.$nextTick(() => {
    //       me.initSwiper();
    //     });
    //   }
    // );
  },
  methods: {
    // initSwiper() {
    //   var me = this;
    //   me.mySwiper = new Swiper("#BannerContainer", {
    //     loop: true,
    //     speed: 1500,
    //     parallax: true,
    //     effect: "fade",
    //     fadeEffect: {
    //       crossFade: true
    //     },
    //     autoplay: {
    //       delay: 3000,
    //       disableOnInteraction: false
    //     },
    //     navigation: {
    //       nextEl: "#BannerButtonPrev",
    //       prevEl: "#BannerButtonNext"
    //     },
    //     pagination: {
    //       el: "#BannerPagination",
    //       clickable: true,
    //       renderBullet: function(index, className) {
    //         return '<span class="' + className + '"></span>';
    //       }
    //     }
    //   });
    //   //鼠标移出隐藏按钮，移入显示按钮
    //   me.mySwiper.el.onmouseover = () => {
    //     var nv = me.mySwiper.navigation;
    //     nv.$nextEl.removeClass("hide");
    //     nv.$prevEl.removeClass("hide");
    //   };
    //   var mouserout = (me.mySwiper.el.onmouseout = () => {
    //     var nv = me.mySwiper.navigation;
    //     nv.$nextEl.addClass("hide");
    //     nv.$prevEl.addClass("hide");
    //   });
    //   mouserout();
    // },
    // loadBannerList(params, onInit) {
    //   let me = this;
    //   getBannerList(params).then(rst => {
    //     me.bannerList = rst.rows;
    //     onInit && onInit();
    //   });
    // }
  }
};
</script>

<style scoped>
.block_ {
  margin: 0 auto;
  width: 100%;
  max-width: 1920px;
  height: 500px;
  background-color: #ffffff;
}
.block {
  width: 100%;
  height: 500px;
  margin-top: 80px;
  background-color: #ffffff;
}
.el-carousel__container {
  /* width: 100%;
  margin: 0 auto; */
  height: 500px;
}
.swiper_img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.swiper-container {
  cursor: pointer;
  width: 100%;
}
.swiper-wrapper {
  overflow: hidden;
}
.swiper-slide {
  width: 100%;
}

.swiper-container .hide {
  opacity: 0;
}

.swiper-container {
  width: 1920px;
  height: 500px;
}

.swiper-slide {
  width: 1920px;
  height: 500px;
}

.swiper_img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper-button-next,
.swiper-button-prev {
  width: 40px;
  height: 40px;
  left: 30px;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 100%;
  transition: opacity 0.5s;
}
.swiper-button-next:after,
.swiper-button-prev:after {
  font-size: 20px;
  color: #dee5f7;
  opacity: 0.5;
}
.swiper-button-next {
  left: auto;
  right: 30px;
}

.swiper-button-next:hover,
.swiper-button-prev:hover {
  background-color: rgba(0, 0, 0, 0.3);
}

.swiper_img {
  width: 100%;
  height: 100%;
  display: block;
}
</style>
<style>
#BannerPagination .swiper-pagination-bullet {
  width: 20px;
  height: 3px;
  background-color: #b4b6c2;
  border-radius: 0;
}
#BannerPagination .swiper-pagination-bullet-active {
  background-color: #fff;
}
</style>